import React, { useState, useEffect } from 'react';
import '../../components/AutomatedClinicAssignment/ClinicAssignment.css';
import { useLocation } from "react-router-dom";

const ClinicAssignment = ({ api, tokenContent }) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState("");
  const [errorResponse, setError] = useState("");


  const handleConfirm = () => {

    setLoading(true);
    setResponse("");
    setError("");
    api.transact("AssignClinicToPatient", {})
      .then(r => {
        setLoading(false);
        let parsedResult;
        try {
          parsedResult = JSON.parse(r?.apiResult || "{}");
        } catch (e) {
          setError("Failed to parse response.");
          return;
        }

        if (parsedResult?.Status === "ERROR" && parsedResult?.Text) {
          setResponse(parsedResult.Text);
        } else {
          setResponse("Successfully referred to patient. You will receive confirmation from IPRS Health shortly. Thank you!");
        }
      })
      .catch(e => {
        setLoading(false);
        setError(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div className="clinic-assignment-container">
      <p className="question">Would you like to accept this request?</p>
      <button
        className="confirm-button"
        onClick={handleConfirm}
        disabled={loading}
      >
        {loading ? "Processing..." : "Confirm"}
      </button>
      {response && <p className="response-message">{response}</p>}
      {errorResponse && <p className="error-message">{errorResponse}</p>}
    </div>
  );
};

export default ClinicAssignment;


